import { createContext, useContext } from 'react'

/**
 * `{ current, open(type, id), close() }` for the entity peek panel, or null
 * outside an EntityPeekProvider (so a link degrades to plain text in a bare
 * test render or a page with no provider).
 */
export const EntityPeekContext = createContext(null)

export function useEntityPeek() {
    return useContext(EntityPeekContext)
}
